import { http } from "Utils/http";
import { Form, Col, Row, Spinner, Button } from 'react-bootstrap';
import {TextButton, IconTextButton, IconButton, CenteredIconTextButton} from 'Components/Button';
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { store } from 'Store';
import {useState, useEffect, useRef} from "react";
import { useSelector, useDispatch } from "react-redux";
import { isInObject } from "Utils/utilityFunctions";
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { generateOrgStatusRpt, generatePSOHistoryInfo } from "Components/Datatable/OrgAxiosFuncs";
import { ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus, setGlobalSuccessStatus } from 'Components/StatusHandling';
import { ICONS } from "Utils/icons";
import ConfirmSavePSOHistoryPopup from "./Component/ConfirmSavePSOHistoryPopup";


const ListOrg = ({ ...props }) => {
    // Date format: mm/dd/yyyy hh: mm
    let location = useLocation();
    const loginInfo = useSelector(state => state.loginInfo);
    const dispatch = useDispatch();
    //const loginState = store.getState().loginInfo;

    const info = props.info;
    const isPSOAdmin = info.isPSOAdmin;
    const isPSOPPCAdmin = info.isPSOPPCAdmin;
    const allowEdit = info.allowEdit;
    const orgType = props.orgType;
    const isLoading = info.isLoading;
    const navigate = useNavigate();

    const [sortColumn, setSortColumn] = useState({
        sortField: "name",
        sortDirection: "asc"
    });

    const [filter, setFilter] = useState(null);
    const [showDownloadPopup, setShowDownloadPopup] = useState(false);

    useEffect(() => {
        var passedData = location.state;

        //console.log("FILTER");
        //console.log(filter);
        //console.log(location);

        if (isInObject("filter", passedData)) {
            //console.log("setFilter");
            setFilter(passedData.filter);
        }
        else {
            setFilter({
                startIndex: 0,
                entryPerPage: 10,
                sortingColumn: sortColumn.sortField,
                sortingOrder: sortColumn.sortDirection,
                searchTerm: ""
            });
        }
        //console.log(filter);
    }, [])

    const getTest = async (filter) => {
        var call = {
            paginationRequest: filter,
            orgType: orgType
        }
        //console.log("CALL");
        //console.log(call);
        //console.log("isPSOAdmin " + isPSOAdmin);
        //console.log("isPSOPPCAdmin " + isPSOPPCAdmin);
        //console.log("allowEdit " + allowEdit);
        var url = '/api/getOrganizationByType';
        const loginState = store.getState().loginInfo;
        return http.post(url, call, {
            headers: {
                "Authorization": "Bearer " + loginState.token
                //"Referrer-Policy": "strict-origin-when-cross-origin"
            }
        });
    }

    const getListCols = (selectedList, sortingInfo) => {
        const listOrganizationColumns = [];
        //console.log(sortColumn + " " + sortOrder);
        const fullNameTitle = function ({ rowName }) {
            //console.log(rowName);
            return "Click the link to view information about " + rowName + ".";
        }
        /*const nameState = function ({ rowName }) {
            //console.log(rowName);
            return { id: rowName.id, orgType: props.orgType, name: rowName.name };
        }*/

        const orgState = function ({ rowName }) {
            //console.log(rowName);

            //console.log(location.state.datatableFilter);

            return {
                id: rowName.id,
                orgType: props.orgType,
                name: rowName.name,

                backRedirect: {
                    path: location.pathname,
                    state: {
                        ...location.state,
                        orgType: props.orgType
                    },

                }
            };
        }

        listOrganizationColumns.push(Datatable_Column({ name: "Organization Name", columnName: "name", selectedRows: selectedList, sortable: true, sortFieldNum: 0, isLink: true, linkData: { title: fullNameTitle, pathname: "/manage/" + orgType + "/viewOrganization", text: null, state: orgState }, sortingInfo: sortingInfo }))
        if (orgType != "Admin") {
            listOrganizationColumns.push(Datatable_Column({ name: "Organization ID", columnName: "psoId", selectedRows: selectedList, sortable: true, sortFieldNum: 1, sortingInfo: sortingInfo }))
        }
        listOrganizationColumns.push(Datatable_Column({ name: "Organization Status", columnName: "organizationStatus", selectedRows: selectedList, sortable: true, sortFieldNum: 2, sortingInfo: sortingInfo }))
        if (allowEdit == true || isPSOAdmin == true || isPSOPPCAdmin == true) {
            listOrganizationColumns.push(Datatable_Column({ name: "Edit", columnName: "edit", selectedRows: selectedList, sortable: false, sortFieldNum: 2, isLink: true, linkData: { title: fullNameTitle, pathname: "/manage/" + orgType + "/editOrganization", text: "Edit", state: orgState }, sortingInfo: sortingInfo }))
        }

        return listOrganizationColumns;
    }

    const tableTitle = function () {
        if (isPSOPPCAdmin == true) {
            return orgType + " Organizations";
        }
        if (isPSOAdmin == true) {
            return "Authorized " + orgType + " Organizations";
        }
        return null;
    }

    const tableDescription = function () {
        if (isPSOPPCAdmin == true) {
            return "Select an organization to view detailed information and its users.";
        }
        else {
            return "Select an organization to view detailed information.";
        }
    }
    const [selectedCount, setSelectedCount] = useState(0);

    const navigateManageVendorAuth = () => {
        navigate("/manage/authorization");
    }

    const navigateCreateOrganization = () => {
        navigate("/manage/" + orgType + "/createOrganization");
    }

    const tooltipSearch = function () {
        if (orgType == 'Admin') {
            return "Search by Organization Name or Status."
        }
        else {
            return "Search by Organization Name, ID, or Status."
        }

    }

    // download organization status report
    const handleFileDownload = async () => {
        const res = await generateOrgStatusRpt("Bearer " + loginInfo.token).catch((error) => {
            //console.log("error handleFileDownload()", error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        //console.log("after handleFileDownload", res);

        if (res?.status?.code === 1) {
            // get filename from the res content-disposition
            const fileName = res.data.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
            //console.log("after handleFileDownload filename", fileName);
            let url = window.URL.createObjectURL(res.data.data);
            let a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a); // append the element to the dom
            a.click();
            a.remove(); // afterwards, remove the element  
        } else {
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: res.data?.status?.text
            });
        }
    }

    const confirmSavePSOHistory = () => {
      setShowDownloadPopup(true);
    }

    const handleCloseDownloadPopup = () => {
      setShowDownloadPopup(false);
    }

    const savePSOHistoryInfo = async () => {
      const res = await generatePSOHistoryInfo("Bearer " + loginInfo.token).catch((error) => {
        const payload = error?.data ?? error;
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: payload?.data?.globalErrorMessageList?.[0] ?? ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
      });

      if (res?.status?.code === 1) {
        if (res?.statusJson?.status === 1 && res?.statusJson?.globalErrorMessageList?.length === 0) {
          // showSavePSOHistoryStatusPopup(res.statusJson);
          setGlobalSuccessStatus({
            dispatch: dispatch,
            popupData: {
              visible: true,
              title: "Success!",
              msg: res?.statusJson?.message!=null ? res?.statusJson?.message : "PSO History information saved successfully.",
              showContactHelp: false
            },
            redirect: {
              redirect: false,
              redirectFirst: false,
              path: "",
              data: {}
            }
          });
        }
        else{
          setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
              visible: true,
              title: ERROR_MESSAGES.DATA_ERROR.title,
              msg: res?.statusJson?.globalErrorMessageList?.[0] ?? ERROR_MESSAGES.DATA_ERROR.message,
              showContactHelp: true
            },
            redirect: {
              redirect: false,
              redirectFirst: false,
              path: "",
              data: {}
            },
            error: res?.statusJson
          });
        }
      } else {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: res?.data?.status?.text
        });
      }
    }

    return (
        isLoading == false
            ? <>
                {
                  orgType=="PSO" && isPSOPPCAdmin &&
                  <ConfirmSavePSOHistoryPopup
                  show={showDownloadPopup}
                  handleClose={handleCloseDownloadPopup}
                  handleDownload={savePSOHistoryInfo}>
                </ConfirmSavePSOHistoryPopup>
                }
                <DatatableBase
                    tableClassName="listOrgTable"

                    filter={filter}
                    setFilter={setFilter}

                    getData={getTest}
                    getListCols={getListCols}
                    setSelectedCount={setSelectedCount}
                    hasSelectableRows={false}
                    searchFieldText={tooltipSearch()}
                    datatableHeader={tableTitle()}
                    datatableDescription={tableDescription()}
                    sortingColumn={sortColumn.sortField}
                    sortingOrder={sortColumn.sortDirection}
                >
                    {allowEdit == true
                        ?
                          <Col lg={12} className="d-flex flex-wrap justify-content-end gap-4">
                            {isPSOPPCAdmin == true
                                ? <TextButton className="ms-auto flex-grow-1 flex-sm-grow-0" onClick={navigateCreateOrganization} variant="normal" content={"Create New " + orgType} />
                                : null
                            }
                            {orgType == "Vendor" && (isPSOAdmin || isPSOPPCAdmin)
                                ?
                                <TextButton className=" flex-grow-1 flex-sm-grow-0" onClick={navigateManageVendorAuth} variant="normal" content={"Manage " + orgType + " Authorization"} />
                                : null
                            }
                            {orgType == "PSO" && isPSOPPCAdmin
                                ?
                                <CenteredIconTextButton
                                    className="flex-grow-1 flex-sm-grow-0 reverse"
                                    icon={ICONS.download}
                                    onClick={handleFileDownload}
                                    variant="normal"
                                    
                                    content={"Organization Status Report"}
                                />
                                : null
                            }
                            {orgType=="PSO" && isPSOPPCAdmin
                                ?
                                <TextButton onClick={confirmSavePSOHistory} className="flex-grow-1 flex-sm-grow-0" variant="normal" content={"Save Current Reporting Year PSO History"}/>
                                : null
                            }
                        </Col>
                        : null
                    }
                </DatatableBase>

            </>
            : null

    );
}

export default ListOrg;